module.exports = __webpack_public_path__ + "assets/img/Forest Dining & Media Room.27d93ae8.jpg";